import { render, staticRenderFns } from "./BrokerageRecordForm.vue?vue&type=template&id=6eef557e&scoped=true"
import script from "./BrokerageRecordForm.vue?vue&type=script&lang=js"
export * from "./BrokerageRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef557e",
  null
  
)

export default component.exports